import { Image, Page, Text, View } from '@react-pdf/renderer';
import { useQuotePdfContext } from '@ui/pages/QuoteBuilder/hooks';
import { styles } from '@ui/pdfs/styles';

import { QuoteLink } from './components/QuoteLink';
import { CustomerQuotePdfTemplate } from './template';

export function CustomerQuote() {
  const { quoteId } = useQuotePdfContext();
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.row}>
        <View style={[styles.section, styles.alignCenter]}>
          <Image
            src={'/images/USA/USA_FASTENER_RGB_PRIMARY_LOGO_AW.png'}
            style={styles.logo}
          />
        </View>
        <View style={styles.section}>
          <Text style={styles.bold}>USA Fastener</Text>
          <Text>1300 Gazin St </Text>
          <Text>Houston, TX 77020 </Text>
          <Text>Phone (713) 641-4600</Text>
        </View>
        <View style={[styles.section, styles.alignCenter, styles.maxWidthFull]}>
          <Text style={[styles.quoteNumber, styles.bold]}>
            Quotation {quoteId}
          </Text>
          <Text style={styles.textSmall}>
            Please refer to the quotation number when ordering
          </Text>
          <QuoteLink />
        </View>
      </View>
      <CustomerQuotePdfTemplate
        showPartDescription
        showLeadTime={false}
        showCustomerPartId
      />

      <View style={styles.row}>
        <View style={[styles.fullRow, styles.gap10]}>
          <Text style={styles.textSmall}>
            All custom generated items are non-refundable / non-returnable.
            Stock Item returns are subject to a minimum 20% restocking fee.
          </Text>
          <Text style={styles.textSmall}>
            MTR's provided at no cost with purchase order request and will be
            delivered with shipped goods. Requests after shipment for MTR's
            $10.00 each
          </Text>
          <Text style={styles.textSmall}>
            Orders less than $50.00 are subject to a $10.00 processing fee.
          </Text>
          <Text style={styles.textSmall}>
            Please contact us if delivered quote does not meet your
            requirements.
          </Text>
          <Text style={styles.textSmall}>
            Typographical and clerical errors are subject to correction.
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.bold, styles.textSmall]}>
            This quotation is made without benefit of viewing any PO directions
            involving dimensional or performance specifications, process
            directions, shipping requirements, QC clauses, or any other
            requirement that may additionally impact the cost of producing the
            quoted product. If such direction occurs with your submission of a
            PO, USA fasteners reserves the right to increase the price of the
            quoted product to compensate for the added activity.
          </Text>
        </View>
      </View>
    </Page>
  );
}
